import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/icons.d.ts').Icon}
 */
const ArrowUpIcon = ({ className = '', width = 13,  height = 13 , color = 'currentColor' }) => {
    return (
        <svg
            className={`icon-13-13 ${className ? className : ''}`}
            fill='none'
            height={height}
            viewBox='0 0 13 13'
            width={width}
            xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M11.5 9L6.5 4L1.5 9'
                stroke={color}/>
        </svg>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

export default ArrowUpIcon;
